import styled from 'styled-components';

export const Conteudo = styled.div`
  margin: 10px;
`;